import {
  RunManualReconciliation,
  GetSFMDisplay,
  SkipNextReconciliationRun,
} from "@helpers/helpers";
import SfmModalStore from "@stores/SfmModalStore";
import myStore from "../store";

export const buildActions = (translate) => {
  return {
    RUN_NOW: {
      actionTypeTag: "RUN_NOW",
      name: translate("reconciliation-streams.actions.RUN_NOW"),
      actionFN: (row) => {
        RunManualReconciliation(
          row.original.ReconciliationStreamId,
          (data) => {
            const sfmData = GetSFMDisplay(data.SFM);
            SfmModalStore.open(sfmData, () => {
              window.location.href = "/reconciliation-streams";
            });
          },
          myStore
        );
      },
      confirmation: true,
      confirmationMessage:
        "Do you want to initiate a manual reconciliation process? Please confirm if you wish to proceed.",
    },
    SKIP_NEXT_RUN: {
      actionTypeTag: "SKIP_NEXT_RUN",
      name: translate("reconciliation-streams.actions.SKIP_NEXT_RUN"),
      actionFN: (row) => {
        SkipNextReconciliationRun(
          row.original.ReconciliationStreamId,
          (data) => {
            const sfmData = GetSFMDisplay(data.SFM);
            SfmModalStore.open(sfmData, () => {
              window.location.href = "/reconciliation-streams";
            });
          },
          myStore
        );
      },
      confirmationMessage:
        "Do you want to skip the upcoming scheduled run? Please confirm if you wish to proceed.",
      confirmation: true,
    },
  };
};
